import { BrowserModule } from '@angular/platform-browser';
import { NgModule } from '@angular/core';
import { HttpClientModule } from '@angular/common/http';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';

import { DataTablesModule } from 'angular-datatables';



import { AppComponent } from './app.component';
import { AppRoutingModule } from './app-routing.module';

import { ClassificationComponent } from './components/classification/classification.component';
import { RelationshipComponent } from './components/relationship/relationship.component';
import { ButtonsModule } from '@progress/kendo-angular-buttons';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { GridModule,ExcelModule } from '@progress/kendo-angular-grid';
import { DropDownListModule } from '@progress/kendo-angular-dropdowns';



import { DropDownsModule } from '@progress/kendo-angular-dropdowns';
import { AutoCompleteModule } from '@progress/kendo-angular-dropdowns';

import {  ClassificationService } from '../app/shared/services/classification.service';

import { ClassificationgrideditformComponent } from './components/classificationgrideditform/classificationgrideditform.component';
import { SearchComponent } from './components/search/search.component'; 
import { RelationshipgridComponent } from './components/relationshipgrid/relationshipgrid.component';
import { DialogsModule } from '@progress/kendo-angular-dialog';
import { ListboxModule } from 'primeng/listbox';
import { DialogModule } from 'primeng/dialog';
import { TableModule } from 'primeng/table';
import {GadoeFrameworkModule} from 'gadoe-framework';
import { RelationshipeditmappingComponent } from './components/relationshipeditmapping/relationshipeditmapping.component';
import { OverlayPanelModule } from 'primeng/overlaypanel';
import { TooltipModule } from '@progress/kendo-angular-tooltip';
import { PopupModule } from '@progress/kendo-angular-popup';
import { ExcelExportModule } from '@progress/kendo-angular-excel-export';
import { CodesearchComponent } from './components/codesearch/codesearch.component';



@NgModule({
  declarations: [
    AppComponent,
    ClassificationComponent,
    RelationshipComponent,
    RelationshipgridComponent,
    SearchComponent,
    ClassificationgrideditformComponent,
    RelationshipeditmappingComponent,
    CodesearchComponent
  ],
  imports: [
    BrowserModule, AppRoutingModule, HttpClientModule, FormsModule, ReactiveFormsModule,
    DataTablesModule,
    ButtonsModule,
    BrowserAnimationsModule,
    GridModule,
    DropDownListModule,
    GridModule,
    ExcelModule,
    DropDownsModule,
    DialogsModule, ListboxModule, DialogModule,
    TableModule, GadoeFrameworkModule, OverlayPanelModule, TooltipModule, PopupModule, ExcelExportModule
  ],
  providers: [ClassificationService],
  bootstrap: [AppComponent]
})
export class AppModule { }
